import { render, staticRenderFns } from "./MeritMatrixSessionFilters.vue?vue&type=template&id=dedc54be"
import script from "./MeritMatrixSessionFilters.vue?vue&type=script&lang=js"
export * from "./MeritMatrixSessionFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports